import Footer from '@/components/Footer';
import FAQ from '@/components/Pages/About/FAQ';
import FAQBuy from '@/components/Pages/Buy/FAQ';
import PriceTier from '@/components/Pages/Buy/PriceTier';

export default function Buy() {
  return (
    <>
      <PriceTier></PriceTier>
      <FAQBuy></FAQBuy>
      <FAQ></FAQ>
      <Footer></Footer>
    </>
  );
}

Buy.layout = 'Main';
